<template>
    <div class="custom-step" :class="customClass" :style="customStyle">
        <div class="custom-step__number" :class="{ 'custom-step__number_filled': isFilled }">{{ number }}</div>
        <div class="custom-step__title" :class="titleClass" :style="titleStyle">{{ $t(title) }}</div>
    </div>
</template>

<script>
export default {
    name: "UiStep",
    props: {
        number: {
            type: Number | String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        isFilled: {
            type: Boolean,
            required: true,
            default: false,
        },
        customClass: {
            type: [String, Array, Object],
            default: null,
        },
        customStyle: {
            type: [String, Object],
            default: null,
        },
        titleClass: {
            type: [String, Array, Object],
            default: null,
        },
        titleStyle: {
            type: [String, Object],
            default: null,
        },
    },
}
</script>

<style scoped>
.custom-step {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    padding: 8px 0;
    width: 100%;
}
.custom-step__number {
    font-family: "Eurostile", sans-serif;
font-weight: 900;
font-size: 12px;
line-height: 100%;
letter-spacing: 0.01em;
text-transform: uppercase;
text-align: center;
color: #007f9f;
width: 30px;
height: 30px;
min-width: 30px;
min-height: 30px;
border: 2px solid #007f9f;
border-radius: 50%;
display: flex;
align-items: center;
justify-content: center;
padding-top: 6px;
}
.custom-step__number.custom-step__number_filled {
    background-color: #007f9f;
    color: #fff;
}
.custom-step__title {
    font-family: "Eurostile", sans-serif;
font-weight: 400;
font-size: 16px;
line-height: 125%;
letter-spacing: 0.01em;
color: #555;
padding-top: 4px;
}
</style>